import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { createCustomer } from 'src/services/napi';
import {
  CreateCustomerProps,
  UseMutationInterfaceWithId
} from './interfaces/useUpdateCustomer.interface';
import { useNotification } from '../../../providers/notificationsProvider';

const updateCustomerData = async (body: CreateCustomerProps): Promise<string | undefined> => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject) return;

  const { _id: projectId } = currentProject;
  // @ts-ignore
  const response = await createCustomer(projectId, body);

  // @ts-ignore
  return response.data.user._id;
};

export const useCreateCustomer = ({ onError, onSuccess }: UseMutationInterfaceWithId) => {
  const { notify } = useNotification();

  return useMutation((data: CreateCustomerProps) => updateCustomerData(data), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: (data) => {
      if (onSuccess && data) {
        onSuccess(data);
      }
    }
  });
};
